module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/light/book-alt.svg?b50582a41b105e28b67367dfe6d03e90";